var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.column.property === 'OverallProductivityPercentage')?_c('strong',{style:({ color: _vm.ProductivityColor })},[_vm._v(" "+_vm._s(_vm.rowValue.toFixed(2))+" % ")]):_c('strong',{style:({ color: _vm.NoProductivityColor })},[_vm._v(" "+_vm._s(_vm.rowValue > 0 ? _vm.rowValue.toFixed(2) : 0)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }